import { faSliders } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dialog, DialogClose, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from '@playcastdotio/Shadcn';
import { VideoBackendSettings } from '../../../components/widgets/VideoBackendSettings';

/** Stream preferences live beside the Beacon studio's default input controls. */
export function BeaconPreferredSettings() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button className='bg-primary theme-midnight:shadow-[inset_2px_3px_2px_#A9E8EA,inset_-2px_-3px_2px_#2D618C] hover:bg-primary/60 focus:bg-midnight active:bg-primary m-0 w-full gap-2 px-2 text-white'>
          <FontAwesomeIcon icon={faSliders} />
          Preferred Settings
        </Button>
      </DialogTrigger>
      <DialogContent className='theme-gray:bg-dark max-h-[90vh] max-w-lg overflow-y-auto bg-gray-900 text-white'>
        <DialogTitle>Preferred Settings</DialogTitle>
        <DialogDescription className='text-gray-300'>
          Choose how this host streams video. Changes apply immediately and are saved for your next stream.
        </DialogDescription>
        <VideoBackendSettings />
        <div className='flex justify-end'>
          <DialogClose asChild>
            <Button variant='secondary'>Close</Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
}
